/* eslint-disable react/prop-types */
import { motion } from "framer-motion";
import FeatureCard from "../components/ui/Card/FeatureCard";
// import ParticleBackground from './ParticleBackground';
// import { colors } from '../theme/colors';

const WhatWeOffer = ({ what_we_offer }) => {
  const firstRow = what_we_offer.slice(0, 3);
  const secondRow = what_we_offer.slice(3);

  return (
    <section className="relative pt-6">
      {/* <ParticleBackground /> */}

      {/* Animated gradient orbs */}
      {/* <div
        className="absolute w-1/2 rounded-full top-1/4 -left-1/4 h-1/2 blur-3xl animate-pulse"
        style={{
          background: `radial-gradient(circle, #FBD1D5/30, #ED1C2E/10)`,
        }}
      />
      <div
        className="absolute w-1/2 delay-1000 rounded-full bottom-1/4 -right-1/4 h-1/2 blur-3xl animate-pulse"
        style={{
          background: `radial-gradient(circle, #ED1C2E/30, #910F1B/10)`,
        }}
      /> */}

      <div className="relative ">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="mb-8 md:mb-12 text-center"
        >
          <motion.div
            initial={{ scale: 0.95, opacity: 0 }}
            whileInView={{ scale: 1, opacity: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: 0.2 }}
            className="inline-block"
          >
            <h2
              className=" text-gray-700 text-2xl md:text-3xl lg:text-5xl font-bold"
              // style={{
              //   background: `linear-gradient(135deg, #FBD1D5, #ED1C2E, #910F1B)`,
              //   WebkitBackgroundClip: "text",
              //   WebkitTextFillColor: "transparent",
              // }}
            >
              What We Offer
            </h2>
          </motion.div>
        </motion.div>

        {/* First row - 3 cards */}
        <div className="grid grid-cols-1 gap-8 mb-8 md:grid-cols-3 lg:gap-12">
          {firstRow.map((feature, index) => (
            <FeatureCard
              key={index}
              {...feature}
              index={index}
              primaryColor="#ED1C2E"
            />
          ))}
        </div>

        {/* Second row - 2 centered cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 lg:gap-12 max-w-[800px] mx-auto">
          {secondRow.map((feature, index) => (
            <FeatureCard
              key={index + 3}
              {...feature}
              index={index + 3}
              primaryColor="#ED1C2E"
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhatWeOffer;
